
import { ArrowRight, CreditCard, Wallet } from "lucide-react";
import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

const ServicosSection = () => {
  return <section id="servicos" className="section-padding bg-gradient-to-b from-white to-gray-50 relative overflow-hidden">
      <div className="absolute inset-0 bg-hero-pattern opacity-5"></div>
      
      <div className="container-custom relative">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-drcash-maastricht-blue mb-6">
            Nossos Serviços
          </h2>
          <div className="h-1 w-20 bg-gradient-to-r from-drcash-caribbean-green to-drcash-tiffany-blue rounded-full mx-auto mb-6"></div>
          <p className="text-gray-700 max-w-2xl mx-auto">Conheça as soluções que impulsionam o crescimento da sua clínica. Oferecemos produtos exclusivos para gestão financeira</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-10">
          <Link to="/boleto-parcelado" className="block">
            <Card className="group border-0 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer bg-gradient-to-br from-drcash-maastricht-blue to-drcash-sapphire-blue">
              <CardContent className="p-8">
                <div className="mb-6">
                  <div className="w-12 h-12 bg-gradient-to-br from-drcash-caribbean-green to-drcash-tiffany-blue rounded-lg flex items-center justify-center mb-4">
                    <Wallet className="h-6 w-6 text-white" />
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-4">Boleto Parcelado</h3>
                  <p className="text-gray-200 mb-4">Ofereça parcelamento facilitado para seus pacientes, sem comprometer o recebimento do seu dinheiro.</p>
                  <ul className="space-y-3 mb-8">
                    <li className="flex items-start gap-3">
                      <span className="w-1.5 h-1.5 rounded-full bg-drcash-caribbean-green mt-2 flex-shrink-0"></span>
                      <span className="text-gray-200">Juros flexíveis a partir de 1,11% e até sem juros para o paciente</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="w-1.5 h-1.5 rounded-full bg-drcash-caribbean-green mt-2 flex-shrink-0"></span>
                      <span className="text-gray-200">Você pode receber em até 48h</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="w-1.5 h-1.5 rounded-full bg-drcash-caribbean-green mt-2 flex-shrink-0"></span>
                      <span className="text-gray-200">Parcele valores de R$250 a R$30 mil em até 24x</span>
                    </li>
                  </ul>
                </div>
                <div className={cn(
                  "inline-flex items-center gap-2 text-drcash-caribbean-green font-semibold",
                  "transition-colors duration-200 hover:text-drcash-tiffany-blue",
                  "group-hover:gap-3"
                )}>
                  Saiba mais <ArrowRight className="h-5 w-5" />
                </div>
              </CardContent>
            </Card>
          </Link>

          <Link to="/antecipacao" className="block">
            <Card className="group border-0 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer bg-gradient-to-br from-drcash-maastricht-blue to-drcash-sapphire-blue">
              <CardContent className="p-8">
                <div className="mb-6">
                  <div className="w-12 h-12 bg-gradient-to-br from-drcash-caribbean-green to-drcash-tiffany-blue rounded-lg flex items-center justify-center mb-4">
                    <CreditCard className="h-6 w-6 text-white" />
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-4">Antecipação de Cartão de Crédito</h3>
                  <p className="text-gray-200 mb-4">Antecipe seus recebíveis de cartão de qualquer maquininha com taxa única de 1,9%</p>
                  <ul className="space-y-3 mb-8">
                    <li className="flex items-start gap-3">
                      <span className="w-1.5 h-1.5 rounded-full bg-drcash-caribbean-green mt-2 flex-shrink-0"></span>
                      <span className="text-gray-200">Receba no mesmo dia para solicitações até 15h</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="w-1.5 h-1.5 rounded-full bg-drcash-caribbean-green mt-2 flex-shrink-0"></span>
                      <span className="text-gray-200">Antecipe múltiplos CNPJs e maquininhas no mesmo dashboard</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="w-1.5 h-1.5 rounded-full bg-drcash-caribbean-green mt-2 flex-shrink-0"></span>
                      <span className="text-gray-200">Processo sem burocracia e 100% online</span>
                    </li>
                  </ul>
                </div>
                <div className={cn(
                  "inline-flex items-center gap-2 text-drcash-caribbean-green font-semibold",
                  "transition-colors duration-200 hover:text-drcash-tiffany-blue",
                  "group-hover:gap-3"
                )}>
                  Saiba mais <ArrowRight className="h-5 w-5" />
                </div>
              </CardContent>
            </Card>
          </Link>
        </div>
      </div>
    </section>;
};

export default ServicosSection;
